import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-check-icon',
  templateUrl: './navigation-check.component.html'
})
export class NavigationCheckComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
